(function () {
  const gate = document.getElementById("age-gate");
  if (gate && sessionStorage.getItem("ss-of-age") === "1") gate.hidden = true;
  document.getElementById("age-enter")?.addEventListener("click", function () {
    sessionStorage.setItem("ss-of-age", "1");
    if (gate) gate.hidden = true;
  });
  document.getElementById("age-leave")?.addEventListener("click", function () {
    window.location.href = "https://www.google.com";
  });

  document.addEventListener("click", function (event) {
  const button = event.target.closest(".menu-toggle");
  if (!button) return;

  const header = button.closest(".site-header");
  const menu = header?.querySelector(".nav-left");
  if (!menu) return;

  event.preventDefault();
  const isOpen = menu.classList.toggle("open");
  button.setAttribute("aria-expanded", String(isOpen));
});

  document.querySelectorAll(".faq").forEach((item) => {
    item.querySelector(".faq-q")?.addEventListener("click", () => item.classList.toggle("open"));
  });

  const drawer = document.getElementById("cart-drawer");
  const backdrop = document.getElementById("cart-backdrop");
  const itemsEl = document.getElementById("cart-items");
  const emptyEl = document.getElementById("cart-empty");
  const countEls = document.querySelectorAll("[data-cart-count]");
  const subtotalEl = document.getElementById("cart-subtotal");
  const footEl = document.querySelector(".drawer-foot");

  function money(cents) {
    try {
      return (cents / 100).toLocaleString(undefined, { style: "currency", currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD" });
    } catch {
      return "$" + (cents / 100).toFixed(2);
    }
  }

  function openCart() {
    if (drawer) drawer.hidden = false;
    if (backdrop) backdrop.hidden = false;
  }
  function closeCart() {
    if (drawer) drawer.hidden = true;
    if (backdrop) backdrop.hidden = true;
  }

  function render(cart) {
    const n = cart.item_count || 0;
    countEls.forEach((el) => { el.textContent = n; });
    if (!itemsEl) return;
    if (!cart.items || !cart.items.length) {
      if (emptyEl) emptyEl.hidden = false;
      itemsEl.innerHTML = "";
      if (footEl) footEl.hidden = true;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    if (footEl) footEl.hidden = false;
    itemsEl.innerHTML = cart.items.map((i) => `
      <div class="cart-item">
        <img src="${i.image || ""}" alt="">
        <div>
          <strong>${i.product_title}</strong>
          <div class="fine">${i.quantity} × ${money(i.final_line_price / i.quantity)}</div>
       <form data-quantity-form
      style="display:flex; flex-wrap:wrap; align-items:center; gap:8px; margin-top:10px;">
<span class="fine">Quantity</span>
<div style="display:flex; align-items:center; gap:6px;">
  <button type="button"
          data-quantity-step="-1"
          aria-label="Decrease quantity"
          style="width:40px; height:40px; background:transparent; color:inherit; border:1px solid #444; border-radius:4px; font-size:20px;">
    −
  </button>

  <input
    type="number"
    name="quantity"
    value="${i.quantity}"
    min="1"
    step="1"
    inputmode="numeric"
    required
    aria-label="Product quantity"
    style="width:54px; height:40px; box-sizing:border-box; padding:6px; text-align:center; background:transparent; color:inherit; border:1px solid #444; border-radius:4px;"
  >

  <button type="button"
          data-quantity-step="1"
          aria-label="Increase quantity"
          style="width:40px; height:40px; background:transparent; color:inherit; border:1px solid #444; border-radius:4px; font-size:20px;">
    +
  </button>
</div>

  <button type="submit"
          style="padding:6px 10px; background:transparent; color:inherit; border:1px solid #444; border-radius:4px;">
    Update
  </button>
  <span data-quantity-error role="alert"
        class="fine" style="flex-basis:100%;"></span>
</form>

       
       
       
       
          </div>
        <button data-remove="${i.key}" aria-label="Remove">✕</button>
      </div>`).join("");
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
    itemsEl.querySelectorAll("[data-quantity-form]").forEach((form, index) => {
    form.querySelectorAll("[data-quantity-step]").forEach((stepButton) => {
    stepButton.addEventListener("click", () => {
      const input = form.querySelector('[name="quantity"]');
      if (input.disabled) return;

      const current = Number.parseInt(input.value, 10);
      const step = Number(stepButton.dataset.quantityStep);

      input.value = Math.max(
        1,
        (Number.isFinite(current) ? current : 1) + step
      );
    });
  });

  
      form.addEventListener("submit", async (event) => {
    event.preventDefault();
    if (!form.reportValidity()) return;

    const input = form.querySelector('[name="quantity"]');
    const button = form.querySelector('button[type="submit"]');
    const errorBox = form.querySelector("[data-quantity-error]");
    const quantity = Number(input.value);

    if (!Number.isInteger(quantity) || quantity < 1) return;

    button.disabled = true;
    input.disabled = true;
    errorBox.textContent = "";

    try {
      const response = await fetch(
        (window.Shopify?.routes?.root || "/") + "cart/change.js",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            id: cart.items[index].key,
            quantity: quantity
          })
        }
      );

      const updatedCart = await response.json();

      if (!response.ok) {
        throw new Error(
          updatedCart.description ||
          updatedCart.message ||
          "Could not update quantity."
        );
      }

      render(updatedCart);
    } catch (error) {
      errorBox.textContent =
        error.message || "Could not update quantity. Please try again.";
    } finally {
      button.disabled = false;
      input.disabled = false;
    }
  });
});

    
    
    itemsEl.querySelectorAll("[data-remove]").forEach((btn) => {
      btn.addEventListener("click", () => {
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: btn.getAttribute("data-remove"), quantity: 0 })
        }).then((r) => r.json()).then(render);
      });
    });
  }

  function refresh() {
    fetch("/cart.js").then((r) => r.json()).then(render).catch(() => {});
  }

  document.querySelectorAll("[data-open-cart]").forEach((el) => {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      openCart();
      refresh();
    });
  });
  document.getElementById("cart-close")?.addEventListener("click", closeCart);
  backdrop?.addEventListener("click", closeCart);

  document.querySelectorAll("[data-product-form]").forEach((form) => {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      const data = new FormData(form);
      fetch("/cart/add.js", { method: "POST", body: data, headers: { Accept: "application/json" } })
        .then((r) => {
          if (!r.ok) return r.json().then((err) => Promise.reject(err));
          return r.json();
        })
        .then(() => { refresh(); openCart(); })
        .catch((err) => {
          const box = form.querySelector("[data-form-error]");
          if (box) box.textContent = (err && err.description) || "Could not place in bag.";
        });
    });
  });

  refresh();
})();
